import { render, staticRenderFns } from "./inscription-importer-page.vue?vue&type=template&id=4f4850ec&"
import script from "./inscription-importer-page.vue?vue&type=script&lang=js&"
export * from "./inscription-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports